import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProductOptionCollection } from 'src/models/DTO/options/productOptionCollection';
import { Config } from '../../../infrastructure/config';

@Injectable({
  providedIn: 'root'
})
export class ProductOptionService {

  private getProductUrl: string = Config.api + "product/option/";

  constructor(private http: HttpClient) { }

  public getProductOption(productId: string) {
    return this.http.get<ProductOptionCollection>(this.getProductUrl + productId + '?include=option,value');
  }
}
